<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import Echo from "laravel-echo";
window.Pusher = require("pusher-js");
export default {
    data() {
        return {
            getActions: [],
        };
    },
    mounted() {
        Pusher.logToConsole = false;
        var pusher = new Pusher("b741dfa9335978add83a", { cluster: "us2" });
        let t = this;
        var channel = pusher.subscribe("channel-display");
        channel.bind("App\\Events\\Display\\ActivityDisplayEvent", function (data) {});
        channel.bind("pusher:subscription_succeeded", function (members) {});
        var callback = function (eventName, data) {
            if (eventName == "App\\Events\\Display\\ActivityDisplayEvent") {
                if (data.pusher) {
                    let d = data.pusher;
                    if (typeof d != "object") {
                        d = eval("(" + d + ")");
                    }
                    t.$store.commit("set_accitonPusher", d);
                }
            }
        };
        //bind to all events on the channel
        pusher.bind_global(callback);
    },
    methods: {},
    wath: {},
};
</script>

<style lang="scss" src="./scss/styles.scss"></style>
